export const selectApp = state => state.app;
export const selectT = state => state.t;
export const selectFlags = state => state.flags;
export const selectLocation = state => state.location;
export const selectSearch = state => state.search;
export const selectDealSearch = state => state.dealSearch;
export const selectLocationSearch = state => state.locationSearch;
